import React from "react";
import { Link } from "react-router";
import { map, some, isNil } from "lodash";

const base_url = "/analysis/team-reports";
const loc = str => (str === "" ? base_url : `${base_url}/${str}`);

const Separator = () => (
  <hr style={{ height: "1px", backgroundColor: "#8F8F8F", width: "100%" }} />
);

const Item = ({
  label,
  active,
  level,
  to,
  search,
  global_location,
  has_arrow,
  is_shown = true
}) => {
  return is_shown ? (
    <Link
      style={{
        paddingLeft: 15 * level + "px"
      }}
      className={to === global_location ? "active" : null}
      to={to + (isNil(search) ? "" : search)}
    >
      {has_arrow === true ? (
        <span
          className={
            global_location.indexOf(to) === 0
              ? "fa fa-chevron-down"
              : "fa fa-chevron-right"
          }
          style={{ fontSize: "11px", fontWeight: "normal" }}
        />
      ) : null}{" "}
      {label}
    </Link>
  ) : null;
};

const menu = state =>
  state.isFinished === true
    ? [
      {
        label: "Team Reports",
        to: loc(""),
        level: 1,
        has_arrow: false,
        children: [
          {
            level: 2,
            label: "Grades & Ranks",
            to: loc("grades-ranks"),
            has_arrow: true,
            children: [
              {
                level: 3,
                label: "Market Share",
                is_shown: state.round <= 2,
                has_arrow: false,
                to: loc("grades-ranks/market-share")
              },
              {
                level: 3,
                label: state.round === 3 ? "Net Revenues" : "Revenues",
                is_shown: state.round <= 3,
                has_arrow: false,
                to: loc("grades-ranks/revenues")
              },
              {
                level: 3,
                label: "Gross Margins",
                is_shown: state.round <= 3,
                has_arrow: false,
                to: loc("grades-ranks/gross-margins")
              },
              {
                level: 3,
                label: "Return on Assets",
                to: loc("grades-ranks/return-on-assets"),
                has_arrow: false,
                is_shown: state.round >= 3
              },
              {
                level: 3,
                label: "Return on Equity",
                to: loc("grades-ranks/return-on-equity"),
                has_arrow: false,
                is_shown: state.round >= 3
              },
              {
                level: 3,
                label: "Earnings per Share",
                to: loc("grades-ranks/earnings-per-share"),
                has_arrow: false,
                is_shown: state.round > 3
              },
              {
                level: 3,
                label: "Share Price",
                has_arrow: false,
                to: loc("grades-ranks/share-price"),
                is_shown: state.round !== 3
              }
            ]
          },
          {
            level: 2,
            label: "FP&A",
            to: loc("fp-a"),
            has_arrow: true,
            children: [
              {
                level: 3,
                label: "Financial Planning & Analysis",
                to: loc("fp-a/financial-planning-and-analysis"),
                has_arrow: false
              }
            ]
          },
          {
            level: 2,
            label: "Marketing Analysis",
            to: loc("marketing-analysis"),
            has_arrow: true,
            children: [
              {
                level: 3,
                label: "Market Share Capture",
                to: loc("marketing-analysis/market-share-capture"),
                has_arrow: false
              },
              {
                level: 3,
                label: "Low Sales 1",
                to: loc("marketing-analysis/low-sales-1"),
                has_arrow: false,
                is_shown:
                  state.messages &&
                  some(
                    state.messages,
                    message => message["type_name"] === "insufficient_capital"
                  )
              },
              {
                level: 3,
                label: "Low Sales 2",
                to: loc("marketing-analysis/low-sales-2"),
                has_arrow: false,
                is_shown:
                  state.messages &&
                  some(
                    state.messages,
                    message =>
                      message["type_name"] === "minimum_requirement_fail" ||
                      message["type_name"] === "price_range_fail" ||
                      message["type_name"] === "distribution_fail"
                  )
              },
              {
                level: 3,
                label: "Customer Survey",
                has_arrow: false,
                to: loc("marketing-analysis/customer-survey")
              },
              {
                level: 3,
                label: "Selling Price",
                to: loc("marketing-analysis/marketing-selling-price"),
                has_arrow: false
              },
              {
                level: 3,
                label: "Awareness",
                has_arrow: false,
                to: loc("marketing-analysis/marketing-awareness")
              },
              {
                level: 3,
                label: "Financial Impact 1",
                to: loc("marketing-analysis/marketing-financial-impact-1"),
                has_arrow: false
              },
              {
                level: 3,
                label: "Financial Impact 2",
                to: loc("marketing-analysis/marketing-financial-impact-2"),
                has_arrow: false
              }
            ]
          },
          {
            level: 2,
            label: "Operational Analysis",
            to: loc("operational-analysis"),
            has_arrow: true,
            children: [
              {
                level: 3,
                label: "Unit Costs",
                to: loc(
                  "operational-analysis/operational-analysis-unit-costs"
                ),
                has_arrow: false
              },
              {
                level: 3,
                label: "Unit Costs Breakdown",
                to: loc(
                  "operational-analysis/operational-analysis-unit-costs-breakdown"
                ),
                has_arrow: false
              },
              {
                level: 3,
                label: "Inventory Management",
                to: loc(
                  "operational-analysis/operational-analysis-inventory-management"
                ),
                has_arrow: false
              },
              {
                level: 3,
                label: "Lead Time",
                to: loc(
                  "operational-analysis/operational-analysis-lead-time"
                ),
                has_arrow: false
              },
              {
                level: 3,
                label: "Financial Impact",
                to: loc(
                  "operational-analysis/operational-analysis-financial-impact"
                ),
                has_arrow: false
              }
            ]
          },
          {
            level: 2,
            label: "Financing Analysis",
            to: loc("financing-analysis"),
            has_arrow: true,
            children: [
              {
                level: 3,
                label: "Capital Structure",
                to: loc(
                  "financing-analysis/financing-analysis-capital-structure"
                ),
                has_arrow: false
              },
              {
                level: 3,
                label: "Cost of Debt & Equity",
                to: loc("financing-analysis/financing-analysis-cost-of-debt"),
                has_arrow: false,
                is_shown: false
              },
              {
                level: 3,
                label: "Impact of Holding Debt",
                to: loc(
                  "financing-analysis/financing-analysis-impact-of-debt"
                ),
                has_arrow: false
              },
              {
                level: 3,
                label: "Cost of Capital",
                to: loc(
                  "financing-analysis/financing-analysis-cost-of-capital"
                ),
                has_arrow: false,
                is_shown: state.round > 4
              },
              {
                level: 3,
                label: "Valuation",
                to: loc("financing-analysis/financing-analysis-valuation"),
                has_arrow: false
              },
              {
                level: 3,
                label: "Shares",
                has_arrow: false,
                to: loc("financing-analysis/financing-analysis-shares")
              }
            ]
          },
          {
            level: 2,
            label: "Financial Statements",
            to: loc("financial-statements"),
            has_arrow: true,
            children: [
              {
                level: 3,
                label: "Income Statement",
                has_arrow: false,
                to: loc("financial-statements/income-statement")
              },
              {
                level: 3,
                label: "Balance Sheet",
                has_arrow: false,
                to: loc("financial-statements/balance-sheet")
              },
              {
                level: 3,
                label: "Cash Flows",
                has_arrow: false,
                to: loc("financial-statements/cash-flows")
              }
            ]
          }
        ]
      }
    ]
    : [
      {
        label: "Team Reports",
        to: loc(""),
        level: 1,
        has_arrow: false,
        children: [
          {
            level: 2,
            label: "Financial Statements",
            to: loc("financial-statements"),
            has_arrow: true,
            children: [
              {
                level: 3,
                label: "Income Statement",
                has_arrow: false,
                to: loc("financial-statements/income-statement")
              },
              {
                level: 3,
                label: "Balance Sheet",
                has_arrow: false,
                to: loc("financial-statements/balance-sheet")
              },
              {
                level: 3,
                label: "Cash Flows",
                has_arrow: false,
                to: loc("financial-statements/cash-flows")
              }
            ]
          }
        ]
      }
    ];

const inSubtree = (item, location) => {
  if (item.to === location) {
    return true;
  }
  if (item.children) {
    return some(item.children, element => inSubtree(element, location));
  }
  return false;
};

const renderItem = (item, global_location) => {
  if (item.type === "separator") {
    return <Separator />;
  }
  return (
    <Item
      key={`${item.level}${item.label}`}
      {...item}
      global_location={global_location}
    />
  );
};

const renderItemTree = (location, search) => item => {
  if (inSubtree(item, location)) {
    return [
      <Item {...item} search={search} global_location={location} />,
      map(item.children || [], renderItemTree(location, search))
    ];
  }
  return renderItem({ ...item, search }, location);
};

const Menu = ({ location, search, ...state }) => (
  <div style={{ display: "flex", flexDirection: "column" }}>
    {map(menu(state), renderItemTree(location, search))}
  </div>
);

export default Menu;



// WEBPACK FOOTER //
// ./src/components/analysis/Menu.js